<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h6 class="fs-5">{{ 'name' | translation }}</h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{ 'name' | translation }}</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>

  <h6 class="fs-5">Origen</h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>Origen</mat-label>
    <mat-select formControlName="type">
      <mat-option [value]="'well'">{{ 'field_water_well' | translation }}</mat-option>
      <mat-option [value]="'reservoir'">{{ 'reports_reservoir' | translation }}</mat-option>
      <mat-option [value]="'tap'">{{ 'reports_tap' | translation }}</mat-option>
      <mat-option [value]="'water_treatment'">{{ 'reports_water_treatment' | translation }}</mat-option>
      <mat-option [value]="'other'">{{ 'DL_otro' | translation }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-primary me-2" (click)="cancel()">
      {{ 'cancel' | translation }}
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid">
      {{ 'save' | translation }}
    </button>
  </div>
</form>
